module.exports = __webpack_public_path__ + "static/media/president.c80f036c.jpg";